import { Table, Dropdown } from 'react-bootstrap';
import './DynamicTable.css';
import { ThreeDotsVertical } from 'react-bootstrap-icons';

const renderCell = (col, row, onAction) => {
    if (col.render) {
        return col.render(row);
    }

    switch (col.type) {
        case 'badge':
            return <span className="badge bg-secondary">{row?.[col.key]}</span>;

        case 'status':
            return (
                <span className={`status ${row?.[col.key] ? 'active' : 'inactive'}`}>
                    {row?.[col.key] ? 'Active' : 'Inactive'}
                </span>
            );

        case 'actions':
            return (
                <Dropdown align="end">
                    <Dropdown.Toggle 
                        id="user-table-action-dd"
                    >
                        <ThreeDotsVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {col?.actions?.map(action => (
                            <Dropdown.Item
                                key={action.key}
                                onClick={() => {
                                    onAction(action.key, row)
                                }}
                            >
                                {action.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            );

        default:
            return row?.[col.key];
    }
};


const DynamicTable = ({ columns = [], data = [], onAction }) => {

    return (
        <Table 
            hover 
            responsive 
            className="dynamic-table"
        >
            <thead>
                <tr>
                    {columns.map(col => (
                        <th key={col.key}>{col.label}</th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {
                    data?.length === 0 ? 
                    (
                         <tr>
                            <td colSpan={columns?.length} className="no-data-cell">
                                No data found
                            </td>
                         </tr>
                    ) :
                    (
                        data?.map(row => (
                            <tr key={row.id}>
                                {columns?.map(col => (
                                    <td key={col.key}>
                                        {renderCell(col, row, onAction)}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )
                }
            </tbody>
        </Table>
    );
};

export default DynamicTable;
